import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { TranslateModule } from '@ngx-translate/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SignInComponent } from './sign-in/sign-in.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetLinkSentComponent } from './reset-link-sent/reset-link-sent.component';

import { SignUpComponent } from './sign-up/sign-up.component';
import {
    RecaptchaModule,
    RECAPTCHA_SETTINGS,
    RecaptchaSettings,
    RECAPTCHA_V3_SITE_KEY,
    RecaptchaV3Module,
    RecaptchaFormsModule,
} from 'ng-recaptcha';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignUpAcknowledgeComponent } from './sign-up-acknowledge/sign-up-acknowledge.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { PasswordResetSuccessfulComponent } from './password-reset-successful/password-reset-successful.component';
import { MatButtonModule } from '@angular/material/button';
import { SignUpVerifiedComponent } from './sign-up-verified/sign-up-verified.component';
import { AppService } from '../../shared/services/auth-service/login-emitter.service';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { environment } from 'src/environments/environment';
import { UnsubscribeEmailComponent } from './unsubscribe-email/unsubscribe-email.component';
export function playerFactory() {
    return player;
}
@NgModule({
    declarations: [
        LoginComponent,
        SignInComponent,
        ResetPasswordComponent,
        ResetLinkSentComponent,
        SignUpComponent,
        SignUpAcknowledgeComponent,
        SetNewPasswordComponent,
        PasswordResetSuccessfulComponent,
        SignUpVerifiedComponent,
        UnsubscribeEmailComponent,
    ],
    imports: [
        LottieModule.forRoot({ player: playerFactory }),
        CommonModule,
        MatInputModule,
        ReactiveFormsModule,
        FormsModule,
        RecaptchaFormsModule,
        RecaptchaModule,
        RecaptchaV3Module,
        AuthRoutingModule,
        TranslateModule,
        CarouselModule,
        MatFormFieldModule,
        MatButtonModule,
        NgxMatIntlTelInputComponent,
        BsDropdownModule,
        NgxIntlTelInputModule,
    ],
    providers: [
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.RECAPTCHA_V3_SITE_KEY,
        },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.RECAPTCHA_V2_SITE_KEY,
            } as RecaptchaSettings,
        },
        AppService,
    ],
    exports: [],
})
export class AuthModule {}
